import { TypeIdSchema } from '@unipile/db';
import { Type, type Static } from '@sinclair/typebox';
import { TypeCompiler } from '@sinclair/typebox/compiler';
import { OauthAuthenticationInputSchema } from '../provider-auth-api/provider-auth-request.schema';
import { OauthProviderSchema } from './provider.schema';

export const OauthFlowStateSchema = Type.Object({
  redirect_uri: Type.String(),
  provider: OauthProviderSchema,
  app_id: TypeIdSchema('app'),
  reconnect_id: Type.Optional(TypeIdSchema('account')),
  v1_instance_port: Type.Optional(Type.Number()),
  scope: Type.Optional(Type.Array(Type.String())),
  unipile_state: Type.Optional(Type.String()),
  login_hint: Type.Optional(Type.String()),
  hosted_auth_session_id: Type.Optional(Type.Number()),
  account_scope_id: Type.Optional(TypeIdSchema('accountScope')),
  signature: Type.String(),
});

export const OauthFlowStateValidator = TypeCompiler.Compile(OauthFlowStateSchema);

export type OauthFlowState = Static<typeof OauthFlowStateSchema>;

export const OauthConfigSchema = Type.Object({
  client_id: Type.String(),
  client_secret: Type.String(),
  redirect_uri: Type.String(),
  scope: Type.Array(Type.String()),
});

export type OauthConfig = Static<typeof OauthConfigSchema>;

export const OauthPostBodySchema = Type.Composite([
  OauthAuthenticationInputSchema,
  Type.Object({
    state: Type.Optional(Type.String()),
    reconnect_id: Type.Optional(TypeIdSchema('account')),
    v1_instance_port: Type.Optional(Type.Number()),
    application_id: TypeIdSchema('app'),
    oauth_config: OauthConfigSchema,
    login_hint: Type.Optional(Type.String()),
    hosted_auth_session_id: Type.Optional(Type.Number()),
    account_scope_id: Type.Optional(TypeIdSchema('accountScope')),
  }),
]);

export type OauthPostBody = Static<typeof OauthPostBodySchema>;

export type OauthDefaults = {
  OAUTH_REDIRECT_URI: string;
  GOOGLE_OAUTH_CLIENT_ID: string;
  GOOGLE_OAUTH_CLIENT_SECRET: string;
  GOOGLE_OAUTH_SCOPE: string;
  MICROSOFT_OAUTH_CLIENT_ID: string;
  MICROSOFT_OAUTH_CLIENT_SECRET: string;
  MICROSOFT_OAUTH_SCOPE: string;
};
